import { Component, OnInit, Inject, EventEmitter } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { DataFlightService, UtilityService } from 'src/app/services';

@Component({
  selector: 'app-airlinelist',
  templateUrl: './airlinelist.component.html',
  styleUrls: ['./airlinelist.component.scss']
})
export class AirlinelistComponent implements OnInit {
  list: any = [];
  selectedAirlines: any[] = []; // Store selected airlines here
  airlinesSelected: EventEmitter<any[]> = new EventEmitter<any[]>(); 

  constructor(public util: UtilityService, public dialogRef: MatDialogRef<AirlinelistComponent>,
    @Inject(MAT_DIALOG_DATA) public data, public dataFlight : DataFlightService) {
      this.list = data.allItems.map(item => {
        const isSelected = data.selectedItems.some(selected => selected.name === item.name);
        return { ...item, isSelected: isSelected };
      });
      this.selectedAirlines = [...data.selectedItems];
    }

  ngOnInit(): void {
  }

  updateSelectedAirlines(item: any, isChecked: boolean) {
    item.isSelected = isChecked;
    isChecked 
      ? this.selectedAirlines.push(item) 
      : this.selectedAirlines = this.selectedAirlines.filter(airline => airline.name !== item.name);
    if (isChecked && !this.selectedAirlines.some(airline => airline.name === item.name)) {
      this.selectedAirlines.push(item);
    }
    this.airlinesSelected.emit(this.selectedAirlines);
    // console.log('Selected Airlines:', this.selectedAirlines);
  }

  onClickAdd() {
    this.dialogRef.close(this.selectedAirlines);
  }
  
  closeDialog() {
    this.dialogRef.close();
  }
  // getAirlineCode(airline: string): string | null {
  //   const match = airline.match(/\(([^)]+)\)/);
  //   return match ? match[1] : null;
  // }
}
